import {
   ChangeDetectionStrategy,
   Component,
   Inject,
   OnDestroy,
   OnInit,
   ViewChild,
   ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { editAllowedIpSubmit } from '../../allowed-ips-register/state/allowed-ip-register.actions';

@Component({
   selector: 'ndt-edit-allowed-ip',
   templateUrl: './edit-allowed-ip.component.html',
   styleUrls: ['./edit-allowed-ip.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
   encapsulation: ViewEncapsulation.None,
   standalone: false,
})
export class EditAllowedIpComponent implements OnInit, OnDestroy, FormComponent {
   @ViewChild(EditAllowedIpComponent) editAllowedIpViewComponent: EditAllowedIpComponent;
   callState: Observable<CallState>;
   selectedAccountId$: Observable<number | null>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   constructor(
      protected store: Store,
      private fb: FormBuilder,
      private dialogService: LcsDialogService,
      public dialogRef: MatDialogRef<EditAllowedIpComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any
   ) {
      this.selectedAccountId$ = this.store.pipe(select(getSelectedAccountId));
   }

   ngOnInit(): void {
      this.initializeForm();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
      this.destroyed$.complete();
   }

   initializeForm(): void {
      this.form = this.fb.group({
         qManageTicketId: [this.data.allowedIp.qManageTicketId, [Validators.required]],
         accountId: [
            {
               accountId: this.data.allowedIp.accountId,
               name: this.data.allowedIp.accountName,
            },
            [Validators.required],
         ],
         status: [this.data.allowedIp.status, [Validators.required]],
      });
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onSave(): void {
      if (!this.form.valid) {
         return;
      }

      this.store.dispatch(
         editAllowedIpSubmit({
            allowedIpAddressId: this.data.allowedIp.allowedIpAddressId,
            qManageTicketId: this.form.value.qManageTicketId,
            accountId: this.form.value.accountId.accountId,
            fields: this.getFormSubmittedEvent(),
         })
      );

      this.dialogRef.close();
   }

   private getFormSubmittedEvent(): string[] {
      return Object.keys(this.form.controls).filter((key) => this.form.get(key)?.dirty);
   }
}
